import formUrlencoded from 'form-urlencoded';
export default function (context, {data, cb}) {
    context.commit('clean');
    context.state.loading = true;
    axios({
        method: 'post',
        url: '/tourclient/payment/items',
        data: formUrlencoded(data, {skipIndex: true}),
        requestId: '/tourclient/payment/items'
    }).then(({data}) => {
        context.rootState.settings.paymentItems.data.ItemsLegend.forEach((leg) => {
          if (!leg.ArrayName) {
            return;
          }
          data.PaymentsList.forEach((item) => {
            item[`${leg.ArrayName}_${leg.ArrayIndex}`] = '';
            item[leg.ArrayName].forEach((arr) => {
              if (arr.FieldName != leg.ArrayIndex) {
                return;
              }
              item[`${leg.ArrayName}_${leg.ArrayIndex}`] = arr.Value;
            });
          });
        });
        context.commit('set', data);
        if (cb) cb(data);
    }).catch(e => {
        context.state.loading = false;
        context.dispatch('error', e, {root: true});
    })
}
